(() => {
  function setup(root) {
    root.querySelectorAll('form[data-class-registration]').forEach((form) => {
      if (form.dataset.classReady) return;
      form.dataset.classReady = 'true';
      const seats = form.querySelector('[name="quantity"]');
      const names = form.querySelector('[name="properties[Attendee names]"]');
      const validateNames = () => {
        const entered = names.value.split(/\r?\n/).map((name) => name.trim()).filter(Boolean);
        names.setCustomValidity(entered.length === Number(seats.value) ? '' : 'Enter one attendee name per line for each seat.');
      };
      seats.addEventListener('input', validateNames);
      names.addEventListener('input', validateNames);
      form.addEventListener('submit', (event) => {
        validateNames();
        if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); }
      });
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
